


















































import { Component, Prop } from 'vue-property-decorator';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/PreparacionEquipos/FiltrosBusqueda.vue';
import ModalCrear from '@/pantallas/Conecta/PreparacionEquipos/ModalCrear.vue';
import ModalAsignacion from '@/pantallas/Conecta/PreparacionEquipos/ModalAsignacion.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
  ColDef,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { fetchAltasCrm } from '@/pantallas/Conecta/AltasCrm/fetchAltasCrm';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';
import Vue from 'vue';

@Component({
  components: {
    MantenedorGrid,
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    ModalCrear,
    ModalAsignacion,
    FormFieldsContainer,
  },
})
export default class Actividades extends ComponenteBase {
  accionesTotales: PermisoAccion[];
  readonly funcionalidad: Funcionalidades = Funcionalidades.AltaCrm;

  @Prop({ default: '' }) AltaCrm_Seleccionada: any;

  filtrobusquedaActividades: string = '';
  gridApi: GridApi = null;
  deshabilitar: boolean = true;
  gridOptions: GridOptions;
  columnDefs: Array<ColDef> = [];
  ordesList: any[] = [];
  columnApi: any = null;
  gridEvent: any = null;
  mounted() {}

  //Busca dentro del resultado de la grilla
  searchDataActividades() {
    this.gridApi.setQuickFilter(this.filtrobusquedaActividades);
    this.gridApi.setDomLayout('autoHeight');
  }

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Alta de Servicio',
        field: 'nombrealtasservicio',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Tipo de Actividad',
        field: 'tipoactividad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Asunto',
        field: 'asunto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Prioridad',
        field: 'prioridad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Referente a',
        field: 'referentea',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Descripción',
        field: 'descripcion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Fecha de Creación',
        field: 'fechacreacion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        valueFormatter: params =>
          params.value && moment(params.value).format('YYYY/MM/DD'),
      },
    ];
    this.gridOptions = {
      pagination: true,
      paginationPageSize: 50,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.ordesList = (await this.getActividades()) || [];
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  getActividades() {
    let self = this;
    let body: any = {};
    body.idAlta = self.AltaCrm_Seleccionada;
    this.loadingService.showLoading(undefined, 'getActividades');
    return fetchAltasCrm({ ...body }, 'conecta_altas_crm/getActividades')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.LISTA;
        }
      })
      .catch((error: any) => null)
      .finally(() => this.loadingService.hideLoading('getActividades'));
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  exportar() {
    let totalFilas = this.gridApi.paginationGetRowCount();
    if (totalFilas > 0) {
      config.crearArchivoCsv(
        'DetalleActividades' + '.csv',
        this.ordesList,
        this.columnDefs
      );
      this.$snotify.success(this.$t('mensajes.mensajesExito.exportar'));
    } else {
      this.$snotify.warning('No existen datos para exportar.');
    }
  }
}
